import React, {Component} from "react"
import {connect} from "react-redux"
import {routerActions} from 'react-router-redux'
import op from "object-path"
import {injectIntl} from 'react-intl'
import {Breadcrumb} from "react-bootstrap"
import IBoxRow from "../../components/IBoxRow"
import PageHeader from "../../components/PageHeader"
import PageBody from "../../components/PageBody"
import {ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADING, EVENT_ENTERPRISE_ACCOUNT_CREATED} from "../../constants"
import Spinner from "../../components/Spinner"
import Alert from "../../components/Alert"
import EnterpriseAccountWithLicenseForm from "./components/EnterpriseAccountWithLicenseForm"
import {RxEmitter} from "rxemitter"
import {alertSuccess} from "../../util/AlertUtil"
import {Link} from "react-router"
import EnterpriseAccountTable from "./components/EnterpriseAccountTable"
import AdminPage from "./components/AdminPage"

function mapStateToProps(state, ownProps) {

  const user = state.user
  const enterpriseAccount = state.enterpriseAccount
  return {
    user,
    enterpriseAccount
  }
}

const mapDispatchToProps = {
  push: routerActions.push,
  createEnterpriseAccount: function (data) {
    return {
      type: ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADING,
      payload: data
    }
  }
}

class CreateEnterpriseAccountView extends Component {

  constructor(data) {
    super(data)
    this.state = {}
  }

  componentWillMount() {
    const format = this.props.intl.formatMessage
    RxEmitter.on(EVENT_ENTERPRISE_ACCOUNT_CREATED).subscribe((x) => {
      alertSuccess(format({id: 'enterprise.account.created'}), "", () => {
        this.props.push(`/admin/enterprise`)
      })
    });
  }

  componentWillReceiveProps(nextProps) {
    /*const id = op.get(nextProps.enterpriseAccount, 'id')
    if(id){
      this.props.push(`/admin/enterprise/account/${id}`)
    }*/
  }

  render() {


    const loading = op.get(this.props.enterpriseAccount, 'loading', false)
    const error = op.get(this.props.enterpriseAccount, 'error')

    const breadcrumb = [
      {label: 'Home', url: '/admin'},
      {label: 'Enterprise', url: '/admin/enterprise'},
      {label: 'Create Enterprise Account', active: true},
    ]

    return (

      <AdminPage
        breadcrumb={breadcrumb}
        title="Create Enterprise Account"
      >
        <Alert show={error} message={error ? error.message : ""}/>
        <Spinner show={loading}/>
        <EnterpriseAccountWithLicenseForm
          onSubmit={(data) => {
            this.props.createEnterpriseAccount(data)
          }}
        />
      </AdminPage>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CreateEnterpriseAccountView))



// WEBPACK FOOTER //
// ./src/routes/admin/CreateEnterpriseAccountView.js